import * as yup from 'yup'

const schema = yup.object().shape({
  expirationDate: yup.date().required('Data de vencimento é obrigatória'),
  orderReferenceDate: yup.date().required('Data de referência é obrigatória'),
  nfeNumber: yup.string().nullable(),
  price: yup.string().required('Valor é obrigatório'),
  sendEmail: yup.boolean(),
})

export default schema
